import StreetLightNumberPresenter from "./Number/StreetLightNumberPresenter";
import PoleNamePresenter from "./PoleName/PoleNamePresenter";
import TitlePresenter from "./Titlle/TitlePresenter";
import ZhagaNodePresenter from "./ZhagaNode/ZhagaNodePresenter";

export const SingleStreetLight ={
    Title : TitlePresenter,
    StreetLightNumber : StreetLightNumberPresenter,
    PoleName : PoleNamePresenter,
    ZhagaNode: ZhagaNodePresenter
}

export default SingleStreetLight;